import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { subscribeSaveState } from './saveBus';
import styles from './SaveIndicator.module.css';

// Bottom-centre pill: "Saving…" (spinner) → "Saved" (check), auto-hides.
const SaveIndicator = () => {
  const [state, setState] = useState('idle');
  useEffect(() => subscribeSaveState((s) => setState(s)), []);
  return (
    <div className={cn(styles.wrap, { [styles.show]: state !== 'idle' })} aria-live="polite">
      {state === 'saved' ? (
        <>
          <CheckRoundedIcon className={styles.check} fontSize="small" />
          Saved
        </>
      ) : (
        <>
          <span className={styles.spinner} />
          Saving…
        </>
      )}
    </div>
  );
};

export default SaveIndicator;
